<script setup lang="ts">
import { Carousel, CarouselContent, CarouselItem } from '@laam/ui/base';
</script>

<template>
	<Carousel
		class="w-full"
		:opts="{
			align: 'start',
			skipSnaps: true,
		}"
	>
		<CarouselContent>
			<CarouselItem class="basis-[45%] md:basis-1/4">
				<slot />
			</CarouselItem>
			<CarouselItem class="basis-[45%] md:basis-1/4">
				<slot />
			</CarouselItem>
			<CarouselItem class="basis-[45%] md:basis-1/4">
				<slot />
			</CarouselItem>
			<CarouselItem class="basis-[45%] md:basis-1/4">
				<slot />
			</CarouselItem>
		</CarouselContent>
	</Carousel>
</template>
